/** tools */
const includeCheck = () => import('../view/tools/includeCheck')
const createPDF = () => import('../view/tools/createPDF')

const path = '/tools'

export default [{
  // 收录检测
  path: path + '/includeCheck',
  component: includeCheck,
  name: "收录检测",
}, {
  // PDF生成
  path: path + '/createPDF',
  component: createPDF,
  name: "PDF生成",
},]